import a, { stdSerializers as t } from "pino";
import { z as u } from "zod";
const l = ["debug", "info", "warn", "error", "fatal", "audit"], g = u.enum(l), c = !process.env.NODE_ENV || process.env.NODE_ENV === "production", p = process.env.NEXT_PHASE === "phase-production-build", f = () => {
  let e = "info";
  c && (e = "warn"), p && (e = "error");
  const r = process.env.LOG_LEVEL, i = g.safeParse(r);
  return i.success && (e = i.data), e;
}, d = {
  level: f(),
  serializers: {
    err: t.err,
    req: t.req,
    res: t.res
  },
  customLevels: {
    debug: 20,
    info: 30,
    warn: 40,
    error: 50,
    fatal: 60,
    audit: 90
  },
  useOnlyCustomLevels: !0,
  timestamp: !0,
  formatters: {
    level: (e) => ({ level: e })
  },
  name: "hivecfm"
}, L = {
  ...d,
  transport: {
    target: "pino-pretty",
    options: {
      colorize: !0,
      levelFirst: !0,
      translateTime: "SYS:standard",
      ignore: "pid,hostname,ip,requestId",
      customLevels: "trace:10,debug:20,info:30,audit:35,warn:40,error:50,fatal:60",
      useOnlyCustomProps: !0
    }
  }
}, v = {
  ...d
}, o = c ? a(v) : a(L), h = {
  debug: o.debug.bind(o),
  info: o.info.bind(o),
  audit: o.audit.bind(o),
  warn: o.warn.bind(o),
  error: o.error.bind(o),
  fatal: o.fatal.bind(o)
}, E = {
  ...h,
  withContext: (e) => o.child(e),
  request: (e) => o.child({
    method: e.method,
    url: e.url
  })
}, s = E, n = (e, r) => {
  r && s.error(r, `Error during shutdown (${e})`), s.info({ event: e }, "Process is exiting"), o.flush();
}, m = () => {
  process.env.NEXT_RUNTIME === "nodejs" && (process.on("uncaughtException", (e) => {
    n("uncaughtException", e);
  }), process.on("unhandledRejection", (e) => {
    n("unhandledRejection", e);
  }), process.on("SIGTERM", () => {
    n("SIGTERM");
  }), process.on("SIGINT", () => {
    n("SIGINT");
  }));
};
if (process.env.NEXT_RUNTIME === "nodejs")
  try {
    m();
  } catch (e) {
    s.error(e, "Error attaching process event handlers");
  }
export {
  s as logger
};
